var map = {
	"./images/@2x/about/banner.jpg": 3606,
	"./images/@2x/about/blur_background.jpg": 4887,
	"./images/@2x/about/caojie.jpg": 2312,
	"./images/@2x/about/circle_core_en.png": 9651,
	"./images/@2x/about/circle_core_zh.png": 3008,
	"./images/@2x/about/gradient_background.jpg": 1043,
	"./images/@2x/about/kevin_zhu.jpg": 3357,
	"./images/@2x/about/lunfei_liang.jpg": 3427,
	"./images/@2x/about/luo_xianshu.jpg": 7039,
	"./images/@2x/about/micowell_logo.png": 8972,
	"./images/@2x/about/partners.png": 6713,
	"./images/@2x/about/wubin_zhou.jpg": 1324,
	"./images/@2x/about/xu_song.jpg": 7221,
	"./images/@2x/about/yunzhong_cheng.jpg": 4790,
	"./images/@2x/about/zhixuan_yin.jpg": 7265,
	"./images/@2x/background_logo.svg": 3792,
	"./images/@2x/index/adjust_strength_background_placeholder.jpg": 4920,
	"./images/@2x/index/app_frame.png": 1394,
	"./images/@2x/index/app_image_1.png": 8092,
	"./images/@2x/index/app_image_2.png": 5489,
	"./images/@2x/index/app_image_3.png": 7372,
	"./images/@2x/index/arrow_up_down.png": 1612,
	"./images/@2x/index/background_p6.jpg": 979,
	"./images/@2x/index/banner_1.jpg": 9012,
	"./images/@2x/index/banner_2.jpg": 7335,
	"./images/@2x/index/banner_3.jpg": 6197,
	"./images/@2x/index/chart_placeholder.png": 6259,
	"./images/@2x/index/control_mode_man.png": 7999,
	"./images/@2x/index/download_phone.png": 2317,
	"./images/@2x/index/fancy_xmai.png": 2141,
	"./images/@2x/index/hand_left.png": 6119,
	"./images/@2x/index/hand_right.png": 8588,
	"./images/@2x/index/handle.png": 3459,
	"./images/@2x/index/handle_horizonal.png": 7271,
	"./images/@2x/index/handle_vertical.png": 624,
	"./images/@2x/index/motor_control_scroll_left.jpg": 2297,
	"./images/@2x/index/motor_control_scroll_right.jpg": 668,
	"./images/@2x/index/motor_scroll_placeholder.png": 9502,
	"./images/@2x/index/phone.png": 566,
	"./images/@2x/index/phone_app_placeholder.png": 3531,
	"./images/@2x/index/puller.png": 7043,
	"./images/@2x/index/qr_code_placeholder.jpg": 21,
	"./images/@2x/index/top_video_placeholder.jpg": 6269,
	"./images/@2x/index/training_1.jpg": 4203,
	"./images/@2x/index/training_2.jpg": 2732,
	"./images/@2x/index/training_3.jpg": 2673,
	"./images/@2x/index/training_4.jpg": 3598,
	"./images/@2x/index/training_5.jpg": 141,
	"./images/@2x/index/training_new_1.jpg": 5474,
	"./images/@2x/index/training_new_10.jpg": 2060,
	"./images/@2x/index/training_new_11.jpg": 8502,
	"./images/@2x/index/training_new_12.jpg": 8949,
	"./images/@2x/index/training_new_13.jpg": 3424,
	"./images/@2x/index/training_new_14.jpg": 8978,
	"./images/@2x/index/training_new_2.jpg": 2694,
	"./images/@2x/index/training_new_3.jpg": 7096,
	"./images/@2x/index/training_new_4.jpg": 1219,
	"./images/@2x/index/training_new_5.jpg": 8104,
	"./images/@2x/index/training_new_6.jpg": 3317,
	"./images/@2x/index/training_new_7.jpg": 6888,
	"./images/@2x/index/training_new_8.jpg": 7513,
	"./images/@2x/index/training_new_9.jpg": 7736,
	"./images/@2x/index/xmai_banner.png": 9899,
	"./images/@2x/index/xmai_pink.png": 5559,
	"./images/@2x/index/xmai_stand.png": 7300,
	"./images/@2x/index/xmai_unfold_black.png": 2300,
	"./images/@2x/logo.svg": 3341,
	"./images/@2x/logo_small.svg": 4269,
	"./images/@2x/product_middle_banner.jpg": 1630,
	"./images/@2x/product_top_banner.jpg": 4296,
	"./images/@2x/product_top_banner_new.jpg": 1344,
	"./images/@2x/product_top_banner_new_new.jpg": 3330,
	"./images/@2x/xmai_wechat.png": 5436,
	"./images/about/banner.jpg": 9811,
	"./images/about/blur_background.jpg": 9007,
	"./images/about/caojie.jpg": 1780,
	"./images/about/circle.png": 3608,
	"./images/about/circle_core_en.png": 2456,
	"./images/about/circle_core_zh.png": 5024,
	"./images/about/gradient_background.jpg": 5170,
	"./images/about/kevin_zhu.jpg": 7054,
	"./images/about/lunfei_liang.jpg": 2878,
	"./images/about/luo_xianshu.jpg": 3524,
	"./images/about/micowell_logo.png": 8474,
	"./images/about/partners.png": 3407,
	"./images/about/wubin_zhou.jpg": 591,
	"./images/about/xu_song.jpg": 1451,
	"./images/about/yunzhong_cheng.jpg": 6355,
	"./images/about/zhixuan_yin.jpg": 6179,
	"./images/background_logo.svg": 1889,
	"./images/gif/adaptive.gif": 7875,
	"./images/gif/adjust_strength_man.gif": 854,
	"./images/gif/constant.gif": 2897,
	"./images/gif/decreasing.gif": 8170,
	"./images/gif/handle_vertical_gif.gif": 8126,
	"./images/gif/increasing.gif": 5935,
	"./images/gif/power_bar.gif": 8299,
	"./images/gif/scroll.gif": 5230,
	"./images/gif/scroll_new.gif": 5115,
	"./images/gif/scroll_new_new.gif": 4099,
	"./images/gif/scroll_new_new_mobile.gif": 1896,
	"./images/gif/spring.gif": 6215,
	"./images/gif/xmai_gif.gif": 5957,
	"./images/gif/xmai_gif_colors.gif": 7789,
	"./images/gif/xmai_gif_once.gif": 9503,
	"./images/index/T槽图片.png": 4546,
	"./images/index/adjust_strength_background_placeholder.jpg": 2046,
	"./images/index/app_frame.png": 7828,
	"./images/index/app_image_1.png": 8034,
	"./images/index/app_image_2.png": 7539,
	"./images/index/app_image_3.png": 704,
	"./images/index/arrow_up_down.png": 8525,
	"./images/index/background_p6.jpg": 6462,
	"./images/index/banner_1.jpg": 4711,
	"./images/index/banner_2.jpg": 403,
	"./images/index/banner_3.jpg": 2865,
	"./images/index/cable.png": 6625,
	"./images/index/chart_placeholder.png": 7068,
	"./images/index/control_mode_chart_placeholder.jpg": 6145,
	"./images/index/control_mode_man.png": 8269,
	"./images/index/control_mode_man_mobile.png": 3432,
	"./images/index/control_mode_weman.png": 3029,
	"./images/index/download_phone.png": 7066,
	"./images/index/fancy_xmai.png": 9248,
	"./images/index/hand_left.png": 9466,
	"./images/index/hand_right.png": 8438,
	"./images/index/handle.png": 1241,
	"./images/index/handle_horizonal.png": 1671,
	"./images/index/handle_vertical.png": 1399,
	"./images/index/motor_control_scroll_left.jpg": 8688,
	"./images/index/motor_control_scroll_right.jpg": 9636,
	"./images/index/motor_scroll_placeholder.png": 3781,
	"./images/index/phone.png": 4404,
	"./images/index/phone_app_placeholder.png": 860,
	"./images/index/puller.png": 9996,
	"./images/index/qr_code_placeholder.jpg": 5430,
	"./images/index/top_video_placeholder.jpg": 2043,
	"./images/index/training_1.jpg": 4367,
	"./images/index/training_2.jpg": 3416,
	"./images/index/training_3.jpg": 9255,
	"./images/index/training_4.jpg": 3333,
	"./images/index/training_5.jpg": 6931,
	"./images/index/training_6.png": 3181,
	"./images/index/training_new_1.jpg": 4195,
	"./images/index/training_new_10.jpg": 4083,
	"./images/index/training_new_11.jpg": 7686,
	"./images/index/training_new_12.jpg": 3241,
	"./images/index/training_new_13.jpg": 4562,
	"./images/index/training_new_14.jpg": 8490,
	"./images/index/training_new_2.jpg": 435,
	"./images/index/training_new_3.jpg": 9820,
	"./images/index/training_new_4.jpg": 6083,
	"./images/index/training_new_5.jpg": 3406,
	"./images/index/training_new_6.jpg": 2548,
	"./images/index/training_new_7.jpg": 5903,
	"./images/index/training_new_8.jpg": 1059,
	"./images/index/training_new_9.jpg": 326,
	"./images/index/xmai_banner.png": 1542,
	"./images/index/xmai_pink.png": 349,
	"./images/index/xmai_stand.png": 1314,
	"./images/index/xmai_unfold_black.png": 7905,
	"./images/index/xmai_unfold_black_new.png": 170,
	"./images/index/展开.png": 1403,
	"./images/index/折叠1.png": 7528,
	"./images/index/折叠2.png": 8983,
	"./images/logo.svg": 2835,
	"./images/logo_small.svg": 7656,
	"./images/product_enjoy_assets.png": 8631,
	"./images/product_enjoy_background.png": 768,
	"./images/product_flagship_assets.png": 5186,
	"./images/product_flagship_background.png": 192,
	"./images/product_middle_banner.jpg": 932,
	"./images/product_standard_assets.png": 7161,
	"./images/product_standard_background.png": 8718,
	"./images/product_top_banner.jpg": 2247,
	"./images/product_top_banner_new.jpg": 4755,
	"./images/product_top_banner_new_new.jpg": 2727,
	"./images/product_top_banner_new_new_new.png": 9549,
	"./images/xmai_wechat.png": 1747
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2474;